<template>
    <div class="footer-row border pb-3">
        <b-row class="ml-0 mr-0 pt-3">
            <b-col sm="12" lg="9" class="footer-left">
                <b-row class="ml-0 mr-0 pt-4">
                    <b-col cols="12" md="12" class="logo-wrapper">
                        <b-img
                            fluid
                            src="/images/02_LVI_logo_vert_LV.png"
                            alt="LU Latviesu valodas institūts"
                            class="lavi-logo"
                        ></b-img>
                        <b-img
                            fluid
                            src="/images/VPP_LOGO.png"
                            alt="Valsts pētījumu programma"
                            class="vpp-logo"
                        ></b-img>
                        <!-- <b-img
                            fluid
                            src="/images/LVPK_Grafikas-zime-H_konturzimejums_RGB_LV_caursp.png"
                            alt="Latvijas Valsts prezidenta kanceleja"
                            class="logo lvpk"
                        ></b-img>
                        <b-img
                            fluid
                            src="/images/LU.jpg"
                            alt="Latvijas Universitāte"
                            class="logo"
                        ></b-img>
                        <b-img
                            fluid
                            src="/images/LNKC.png"
                            alt="Latvijas Nacionālais kultūras centrs"
                            class="logo"
                        ></b-img>
                        <b-img
                            fluid
                            src="/images/Ziedona muzejs.png"
                            alt="Ziedoņa muzejs"
                            class="logo"
                        ></b-img>
                        <b-img
                            fluid
                            src="/images/LZA_LOGO.jpg"
                            alt="Latvijas Zinātņu akadēmija"
                            class="lza"
                        ></b-img>
                        <b-img
                            fluid
                            src="/images/Stastnieki.png"
                            alt="Latvijas Stāstnieku asociācija"
                            class="logo"
                        ></b-img> -->
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" lg="3" class="footer-right">
                <div class="contacts pt-4">
                    <h5>Kontakti</h5>
                    <p>
                        <span
                            >Latvijas Universitātes Latviešu valodas institūts
                        </span>
                        <span>Kalpaka bulvāris 4</span>
                        <span>Rīga, LV-1050 </span>
                    </p>

                    <p>
                        <span>Tālrunis: 67034016 </span>
                        <span>E-pasts: lavi@lu.lv </span>
                    </p>
                </div>
            </b-col>
        </b-row>
        <div class="copyrights-row">
            <b-link>© 2022 LU LaVI</b-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "appFooter",
};
</script>

<style lang="scss" scoped>
@import "~@/_variables.scss";

.footer-row {
    // height: 250px;
    width: 100%;
    box-shadow: inset 0 30px 21px -21px #d0cccc;
}

.footer-left {
    // justify-content: flex-start;
    // align-items: center;
    // display: flex;

    img {
        padding: 8px;
    }
}

.footer-right {
    justify-content: flex-end;
    align-items: center;
    display: flex;
}

.contacts {
    padding-right: 48px;
    color: $grey-text;
}

.contacts span {
    display: block;
}

.copyrights-row {
    text-align: center;

    a {
        color: grey;
        cursor: pointer;
        text-decoration: underline;

        &:hover {
            color: $black !important;
        }
    }
}
.logo {
    width: 175px;
}
.lza {
    width: 175px;
}

.lavi-logo {
    width: 200px;
}

.logo-wrapper {
    // text-align: center;
}

.lvpk {
    width: 300px;
}

.vpp-logo {
    width: 370px;
}

@media (max-width: $lg-media - 1) {
    .logo-wrapper {
        text-align: center;
    }
    .footer-left {
        justify-content: center;
        padding-top: 32px;
    }

    .footer-right {
        justify-content: center;

        .contacts {
            padding-right: 0px;
        }
    }
}

@media (max-width: $sm-media - 1) {
    .footer-left .logo {
        width: 200px;
    }
    .lza {
        width: 200px;
    }

    .lvpk {
        width: 200px;
    }
}

@media (max-width: 450px) {
    .footer-left {
        display: block;
    }
    .footer-left .logo {
        width: 250px;
        display: block;
        margin: 0 auto;
    }

    .lza {
        width: 250px;
        display: block;
        margin: 0 auto;
    }

    .lvpk {
        width: 250px;
        display: block;
        margin: 0 auto;
    }
}
</style>
